/**
 * Sanitizes an href by removing everything after the last underscore-number pattern.
 * If the href contains multiple _123 patterns, it removes everything after the last one.
 * This helps clean up URLs that may have additional encoded parameters or suffixes.
 *
 * @param {string | undefined} href - The href string to sanitize
 * @returns {string} The sanitized href string, or empty string if href is falsy
 *
 * @example
 * // Returns: "https://help.prusa3d.com/article/the-benchy-hull-line_124745"
 * sanitizeHref("https://pkb.local/search/https%3A%2F%2Fhelp.prusa3d.com%2Farticle%2Fthe-benchy-hull-line_124745%25E0%25B9%2580%25E0%25B8%25A5%25E0%25B8%25A2%25E0%25B8%2599%25E0%25B8%25B0")
 */
export const sanitizeHref = (href: string | undefined): string => {
  if (!href) {
    return '';
  }

  // remove everything after the last _123 pattern
  const match = href.match(/^(.*_\d+)/);
  if (match) {
    return match[1];
  }

  return href;
};
